import axios from 'axios';
import { getUrl } from 'Router/urlConfig';
import { getDataFromLocalStorage } from 'dist/Storage/localStorageMethods';

export default async function getVacantest() {
  const apiUrl = getUrl('api');
  const { token } = getDataFromLocalStorage('vacanted');

  return axios.get(`${apiUrl}/collection/type/vacantest`, {
    headers: {
      authorization: token,
    },
  })
    .then((resp) => resp)
    .catch((error) => error);
}
